Ext.define('SA.AcsTable.EditViewFactory', {
    singleton: true,

    createEditView({model, observable}) {
        var view = Ext.widget({xtype: 'acs-edit-view'}),
            cmps = {
                checkboxList: view.down('#checkboxList'),
                doneBtn: view.down('#doneBtn'),
                messageCmp: view.down('#messageCmp'),
                selectionBtns:  view.down('#selectionBtns'),
                titleCmp: view.down('#titleCmp'),
                unselectableLocationsList: view.down('#unselectableLocationsList'),
                unselectableLocationsSection: view.down('#unselectableLocationsSection')
            },
            projectView = SA.ProjectView.createHidden(view),
            locationRenderer = new SA.view.LocationRenderer({svgIconCls: 'sa-edit-location-label-icon'}),
            fireRefreshView = () => observable.fireEvent('refreshView'),
            getTitleHtml = state => `Edit ${Ext.String.htmlEncode(state.getViewName())}`,
            getUnviewableMessage = state => ({
                NoSelectableLocations: 'Please add a location to the project.',
                NoSelectedLocations: 'Please select a location to view the report.'
            }[state.getReasonUnviewable()]),
            checkboxListRenderer = SA.controller.ListCmpRenderer.create({
                listCmp: cmps.checkboxList,
                itemXtype: 'edit-view-checkbox',
                getItemModelId: itemModel => itemModel.getStringId(),
                getItemModels: state => state.getSelectableLocations(),

                updateItemCmp: ({state, itemModelId, itemModel, itemCmp}) => {
                    itemCmp.setLabelHtml(locationRenderer.renderLocation(itemModel));
                    itemCmp.setCheckedSuppressed(state.isSelectedLocationId(itemModelId));
                },

                onCreate: ({itemModelId, itemCmp}) => {
                    itemCmp.on('check', () => model.addLocation(itemModelId));
                    itemCmp.on('uncheck', () => model.removeLocation(itemModelId));
                }
            }),
            unselectableLocationListRenderer = SA.controller.ListCmpRenderer.create({
                listCmp: cmps.unselectableLocationsList,
                itemXtype: 'edit-view-unselectable-list-item',
                getItemModelId: itemModel => itemModel.getStringId(),
                getItemModels: state => state.getUnselectableLocations(),

                updateItemCmp: ({itemModel, itemCmp}) => {
                    itemCmp.setLabelHtml(locationRenderer.renderLocation(itemModel));
                }
            });

        cmps.doneBtn.on('click', () => SA.AppController.showProjectView(model));

        cmps.selectionBtns.on('selectAll:click', () => model.addLocations(checkboxListRenderer.getItemModelIds()));
        cmps.selectionBtns.on('clear:click', () => model.clearLocations());

        model.on('stateResolved', fireRefreshView);

        observable.on('show', () => {
            SA.SidebarState.create()
                .enableTabs(['locations'])
                .selectTab('locations')
                .setModel(model)
                .apply();

            SA.HistoricalModeIndicator.maybeShow(model);
            SA.PageHeader.setView(model);
            SA.ProjectViewToolbar.clearToolbar();
            SA.ViewChooser.setView(model);
            SA.ProjectView.show(projectView);

            fireRefreshView();
        });

        observable.on('refreshView', () => {
            var state = model.getState();

            cmps.titleCmp.update(getTitleHtml(state));

            if (state.isViewable()) {
                cmps.doneBtn.enable();
                cmps.messageCmp.hide();
            }
            else {
                cmps.doneBtn.disable();
                cmps.messageCmp.update(getUnviewableMessage(state));
                cmps.messageCmp.show();
            }

            cmps.selectionBtns.setEnabled(state.hasSelectableLocations());

            checkboxListRenderer.renderState(state);

            unselectableLocationListRenderer.renderState(state);
            cmps.unselectableLocationsSection.setVisible(state.hasUnselectableLocations());
        });
    }
});